// Cada services.js del proyecto crea su propia instancia con axios.create()
// (no hay un cliente HTTP compartido) y hasta ahora cada uno arma la URL
// pegándole "?token=" (ver Session.getToken()). Para pasar a mandar el token
// por header Authorization sin tener que tocar los ~80 archivos services.js
// uno por uno, se parchea acá axios.create(): todas las instancias que se
// creen de ahora en más (sin importar en qué archivo) quedan con un
// interceptor que agrega el header automáticamente.
//
// Debe importarse antes que cualquier otro modulo que pueda llamar a
// axios.create() (por eso el import está primero en main.js).
import axios from 'axios'
import Session from '@/handler/session'

const nativeCreate = axios.create.bind(axios)

axios.create = function (config) {
  const instance = nativeCreate(config)

  instance.interceptors.request.use((requestConfig) => {
    const session = Session.getSession()
    if (session.auth && session.auth.token) {
      requestConfig.headers.Authorization = 'Bearer ' + session.auth.token
    }
    return requestConfig
  })

  return instance
}
